export default "__VITE_ASSET__393d725b__"